import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export default class ProductDetail {
  constructor() { this.init(); }

  init() {
    const galleryEl = document.querySelector(".js-product-gallery");
    if (!galleryEl) return;

    new Swiper(galleryEl, {
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: ".js-product-next",
        prevEl: ".js-product-prev",
      },
      pagination: {
        el: ".js-product-pagination",
        clickable: true,
      },
      slidesPerView: 1,
      loop: true,
      speed: 600,
      observer: true,
      observeParents: true,
    });
  }
}
